<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import type { HTMLAttributes } from 'vue'

type TSubdistrictWithDistrict = {
  id: number
  name: string
  district_id?: number
}

const props = withDefaults(
  defineProps<{
    modelValue?: number | null
    title?: string
    district?: boolean
    class?: HTMLAttributes['class']
    placeholder?: string
    icon?: string
  }>(),
  {
    modelValue: undefined,
    title: undefined,
    district: false,
    class: undefined,
    placeholder: undefined,
    icon: 'material-symbols:search'
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value?: number | null): void
  (e: 'update:title', value?: string): void
}>()

const { $recaptcha } = useNuxtApp()
const model = useVModel(props, 'modelValue', emit)
const modelTitle = useVModel(props, 'title', emit)
const tempList = ref<TSubdistrictWithDistrict[]>()

const placeholder = computed(() => {
  return props.district
    ? props.placeholder || 'Masukkan Kecamatan/Kabupaten/Kode Pos...'
    : props.placeholder || 'Masukkan Desa/Kelurahan/Kecamatan/Kode Pos...'
})

const searchHandler = async (q: string) => {
  if (q.length < 3) return

  const getToken = await $recaptcha?.getToken('address_search')
  if (!getToken) return

  const data = await $fetch(`/intl-api/address`, {
    method: 'POST',
    body: {
      captcha: getToken,
      q
    }
  })

  tempList.value = (data?.data ?? []).map((item) => ({
    ...item,
    name: [
      item.sub_district_name,
      item.district_name,
      item.region_name,
      item.province_name
    ].join(', ')
  }))

  return tempList.value
}

watch(model, (newValue) => {
  if (newValue) {
    const findTitle = tempList.value?.find((item) => item.id === newValue)
    modelTitle.value = findTitle?.name
  }
})

const combobox = useTemplateRef('combobox')
defineExpose({
  combobox
})
</script>
<template>
  <UiComboboxBase
    ref="combobox"
    v-model="model"
    :title="modelTitle"
    :class="props.class"
    :placeholder="placeholder"
    :search="searchHandler"
    :icon="icon"
  />
</template>
